import Vue from 'vue';
import { PiniaVuePlugin, createPinia, setActivePinia } from 'pinia';
import { piniaPersistedState } from './pinia-persisted.client';

Vue.use(PiniaVuePlugin);

export default (ctx, inject) => {
	const pinia = createPinia();

	// Aggiungi il plugin di persistenza con SecureLS
	pinia.use(piniaPersistedState);

	// in SPA basta attivarlo una volta
	setActivePinia(pinia);

	// esponilo sull'app e su this.$pinia / ctx.$pinia
	ctx.app.pinia = pinia;
	inject('pinia', pinia);
};
